<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout >
          <v-flex xs12>
            <p class="display-1 text-no-wrap text-md-center font-weight-thin font-italic"></p>
            <v-card class="mx-auto" max-width="500">
              <v-img
                src="https://cdn.clinic.inf.br/public/clinic/logo.svg"
                class="grey lighten-2"
              ></v-img>
              <div class="backgroud-logo logo">
              </div>
              <v-card-title primary-title>
                <v-card-text>
                  <v-form @keyup.enter.native="submit()" action="#" v-model="valid" ref="form" lazy-validation @submit.prevent="submit()">

                    <v-text-field
                      label="E-Mail"
                      v-model="auth.username"
                      :rules="usernameRules"
                      required
                    ></v-text-field>

                    <v-text-field
                      v-model="auth.password"
                      :append-icon="e1 ? 'visibility' : 'visibility_off'"
                      :type="e1 ? 'text' : 'password'"
                      name="input-10-1"
                      label="Senha"
                      @click:append="e1 = !e1"
                    ></v-text-field>

                    <v-checkbox
                      label="Lembre me"
                      v-model="auth.remeberMe"
                      :color="this.getTheme.color"
                    ></v-checkbox>

                    <router-link to="/auth/forget-password">
                      <p class="text-xs-right title">Esqueceu sua senha?</p>
                    </router-link>

                    <v-btn
                      :color="this.getTheme.color"
                      block
                      :disabled="!valid"
                      @click="submit()"
                      dark
                    >
                      Login
                    </v-btn>
                    <br><hr><br>

                    <router-link to="/auth/search-user">
                      <v-btn
                        block
                      >Cadastrar</v-btn>
                    </router-link>

                  </v-form>

                </v-card-text>
              </v-card-title>
              <v-card-actions>
                <div>
                  <p>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</p>
                  <p>Versão: {{getPkg.pkg.version}}</p>
                </div>

              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-snackbar
          :timeout="snackbarConfig.timeout"
          :color="snackbarConfig.color"
          :multi-line="snackbarConfig.mode === 'multi-line'"
          :vertical="snackbarConfig.mode === 'vertical'"
          v-model="snackbarConfig.snackbar"
        >
          {{ snackbarConfig.text }}
          <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  // import { url } from '../../../config/api.link.connection'
  // import customersTheme from '../../../config/customersTheme'

  export default {
    name: 'Login',
    computed: {
      ...mapGetters({ customer: 'customer' }),
      ...mapGetters('app', ['getTheme', 'getPkg'])
    },
    mounted () {
      this.$vuetify.theme.primary = this.getTheme.colorHTML // this.getTheme.color
      if (process.env.NODE_ENV !== 'production') {
        this.auth.username = 'andreza_82@hotmail.com'
        this.auth.password = '123456'
      }
    },
    data: () => ({
      env: process.env,
      password: 'Password',
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      usernameRules: [
        (v) => !!v || 'E-Mail obrigatório!'
      ],
      passwordRules: [
        (v) => !!v || 'Senha obrigatória!'
      ],
      valid: true,
      e1: false,
      auth: {
        username: '',
        password: '',
        id: '',
        client: '',
        name: '',
        remeberMe: false
      }
    }),
    methods: {
      ...mapActions('auth', ['setLogin']),
      submit (e) {
        if (this.$refs.form.validate()) {
          this.setLogin(this.auth).then(() => {
          }).catch((err) => {
            if (err.response.data.message) {
              this.snackbarConfig.snackbar = true
              this.snackbarConfig.text = err.response.data.message
              return false
            }
            if (err.response.data.errors) {
              if (err.response.data.errors.username) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.msg
                return false
              }
              if (err.response.data.errors.password) {
                this.snackbarConfig.snackbar = true
                this.snackbarConfig.text = err.response.data.errors.username.password.msg
                return false
              }
            }
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue